<template>

    <div>

      <v-footer fixed class="pa-0">

        <v-toolbar class="ma-0" @click.stop="alarmsPopup = true">

          <v-spacer></v-spacer>

          <v-toolbar-title class="ma-2 hidden-md-and-down">{{ $t('Alarms') }}</v-toolbar-title>

          <v-chip
            class="ma-2"
            color="#9d9d9d"
            text-color="white"
          >
            <v-avatar
              left
              color="#585858"
              class="darken-4"
            >
              {{alarm_stats.prio0}}
            </v-avatar>
            {{ $t('Warning(s)') }}
          </v-chip>

          <v-chip
            class="ma-2"
            color="#0f0f0f"
            text-color="red"
          >
            <v-avatar
              left
              color="#0f0f0f"
              class="darken-4"
            >
              {{alarm_stats.prio1}}
            </v-avatar>

            {{ $t('Alarms') }}

          </v-chip>
          
          <v-btn icon @click.stop="alarmsPopup = true">
            <v-icon>mdi-chevron-up</v-icon>
          </v-btn>
        </v-toolbar>
        
      </v-footer>

      <v-snackbar
        v-model="app.snackbar.show"
        :color="app.snackbar.color"
      >
        {{ app.snackbar.text }}

        <v-btn
          color="white"
          text
          @click="app.snackbar.show = false"
        >
          Close
        </v-btn>

      </v-snackbar>
      
      <v-row justify="center">

        <v-dialog v-model="alarmsPopup" fullscreen hide-overlay transition="dialog-bottom-transition">

          <v-card>

            <v-toolbar color="white">

              <v-toolbar-title>{{ $t('Alarms') }}</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn icon @click="alarmsPopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              
            </v-toolbar>

            <v-container>

              <h1 class="py-10">{{ $t('Active alarms') }}</h1>

              <alarmsComponent />

            </v-container>

          </v-card>
        
        </v-dialog>

      </v-row>
      
    </div>

</template>

<script>

import { mapGetters } from "vuex" ;
import alarmsComponent from '@/components/alarms/Alarms' ;

export default {

  name: 'Footer',
  computed: {

      ...mapGetters({
          app: "app/data",
          alarm_stats: "reporters/alarm_stats",
          user: "user/current",
          currentCompany: "companies/currentCompany",
      }),

  },
  components: {
    alarmsComponent,
  },
  data: () => ({
    alarmsPopup: false,
  }),

};

</script>
